const locale = {
   Redo: 'Bekor qilish',
   Undo: 'Orqaga qaytarish',
   Cut: 'Kesib olish',
   Copy: 'Nusxa olish',
   Paste: 'Qo\u2018yish',
   'Select all': 'Barchasini belgilash',
   'New document': 'Yangi hujjat',
   Ok: 'Bajarish',
   Cancel: 'Bekor qilish',
   'Visual aids': 'Ko\u2018rgazmali o\u2018quv qurollar',
   Bold: "Yo'g'on",
   Italic: 'Yotiq',
   Underline: 'Tagi chizilgan',
   Strikethrough: "O'chirilgan yozuv",
   Superscript: 'Yuqori yozuv',
   Subscript: 'Quyi yozuv',
   'Clear formatting': 'Formatlashni tozalash',
   'Align left': 'Chapga tekislash',
   'Align center': 'Markazga tekislash',
   'Align right': "O'ngga tekislash",
   Justify: 'Ikki tomondan tekislash',
   'Bullet list': 'Nuqtali ro\u2018yxat',
   'Numbered list': 'Raqamli ro\u2018yxat',
   'Decrease indent': 'Satr boshini kamaytirish',
   'Increase indent': 'Satr boshini oshirish',
   Close: 'Yopish',
   Formats: 'Formatlar',
   "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
      'Sizning brauzeringiz buferga to\u2018g\u2018ridan-to\u2018g\u2018ri kirish qo\u2018llab-quvvatlamaydi. O\u2018rniga klaviaturaning Ctrl+X/C/V qisqartirishlarni foydalaning.',
   Headers: 'Sarlavhalar',
   'Header 1': 'Sarlavha 1',
   'Header 2': 'Sarlavha 2',
   'Header 3': 'Sarlavha 3',
   'Header 4': 'Sarlavha 4',
   'Header 5': 'Sarlavha 5',
   'Header 6': 'Sarlavha 6',
   Headings: 'Sarlavhalar',
   'Heading 1': 'Sarlavha 1',
   'Heading 2': 'Sarlavha 2',
   'Heading 3': 'Sarlavha 3',
   'Heading 4': 'Sarlavha 4',
   'Heading 5': 'Sarlavha 5',
   'Heading 6': 'Sarlavha 6',
   Div: 'Div',
   Pre: 'Pre',
   Code: 'Kod',
   Paragraph: 'Paragraf',
   Blockquote: 'Matn blok parchasi',
   Inline: 'Bir qator ketma-ketlikda',
   Blocks: 'Bloklar',
   'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.':
      "Qo'shish oddiy matn rejimida amalga oshiriladi. Ushbu hususiyatni o'chirmaguningizcha, kontent oddiy matn sifatida qo'shiladi.",
   'Font Family': 'Srift turi',
   'Font Sizes': 'Shrift kattaligi',
   Class: 'Klass',
   'Browse for an image': 'Rasmni yuklash',
   OR: 'YOKI',
   'Drop an image here': "Bu erga rasmni olib o'ting",
   Upload: 'Yuklash',
   Block: 'Blok',
   Align: 'Saflamoq',
   Default: 'Standart',
   Circle: 'Doira',
   Disc: 'Disk',
   Square: 'Kvadrat',
   'Lower Alpha': 'Kichik lotincha',
   'Lower Greek': 'Pastki yunon',
   'Lower Roman': 'Kichik kirilcha',
   'Upper Alpha': 'Katta lotincha',
   'Upper Roman': 'Katta kirilcha',
   Anchor: 'Langar',
   Name: 'Nomi',
   Id: 'Id',
   'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.':
      "Id faqat harf bilan boshlanishi lozim, o'z ichiga faqat harflar, sonlar, tire, nuqtalar, pastgi chiziqlardan iborat bo'lishi mumkin",
   'You have unsaved changes are you sure you want to navigate away?':
      "Sizda saqlanmagan o'zgartirishlar bor. Boshqa yerga chiqib ketish uchun ishonchingiz komilmi?",
   'Restore last draft': 'Oxirgi ',
   'Special character': 'Maxsus belgilar',
   'Source code': 'Manba kodi',
   'Insert/Edit code sample': "Kod namunasini qo'shish / tahrirlash",
   Language: 'Til',
   'Code sample': 'Kod namunasi',
   Color: 'Rang',
   R: 'R',
   G: 'G',
   B: 'B',
   'Left to right': "Chapdan o'ngga",
   'Right to left': "O'ngdan chapga",
   Emoticons: 'Hissiyot ikonkalari',
   'Document properties': 'Hujjatning xususiyatlari',
   Title: 'Nomi',
   Keywords: "Kalit so'zlar",
   Description: 'Tavsif',
   Robots: 'Robotlar',
   Author: 'Muallif',
   Encoding: 'Kodlash',
   Fullscreen: 'Butun ekran rejimi',
   Action: 'Harakat',
   Shortcut: 'Yorliq',
   Help: 'Yordam',
   Address: 'Manzil',
   'Focus to menubar': "Menubarga e'tibor qaratish",
   'Focus to toolbar': "Vositalar paneliga e'tibor qaratish",
   'Focus to element path': "Elementlar manziliga e'tibor qaratish",
   'Focus to contextual toolbar':
      "Kontekstli vositalar paneliga e'tibor qaratish",
   'Insert link (if link plugin activated)':
      "Havolani qo'shish (havola plagini o'rnatilgan bo'lsa)",
   'Save (if save plugin activated)':
      "Saqlash (saqlash plagini o'rnatilgan bo'lsa)",
   'Find (if searchreplace plugin activated)':
      "Qidirish (qidirish plagini o'rnatilgan bo'lsa)",
   'Plugins installed ({0}):': "O'rnatilgan plaginlar ({0})",
   'Premium plugins:': 'Premium plaginlar:',
   'Learn more...': "Batafsil ma'lumot...",
   'You are using {0}': 'Siz {0} ishlatmoqdasiz',
   Plugins: 'Plaginlar',
   'Handy Shortcuts': 'Foydalanadigan yorliqlar',
   'Horizontal line': 'Gorizontal chiziq',
   'Insert/edit image': "Rasmni qo'shish / tahrirlash",
   'Image description': 'Rasm tavsifi',
   Source: 'Manba',
   Dimensions: "O'lchamlari",
   'Constrain proportions': 'Nisbatlarni cheklash',
   General: 'Umumiy',
   Advanced: "Ilg'or",
   Style: 'Uslub',
   'Vertical space': "Vertikal o'lchov",
   'Horizontal space': "Gorizontal o'lchov",
   Border: 'Chegara',
   'Insert image': "Rasm qo'shish",
   Image: 'Rasm',
   'Image list': "Rasmlar ro'yhati",
   'Rotate counterclockwise': "Soatga qarshi yo'nalishda aylantirish",
   'Rotate clockwise': "Soat yo'nalishda aylantirish",
   'Flip vertically': "Vertikal o'girish",
   'Flip horizontally': "Gorizontal o'girish",
   'Edit image': 'Rasmni tahrirlash',
   'Image options': 'Rasm imkoniyatlari',
   'Zoom in': 'Yaqinlashtirish',
   'Zoom out': 'Uzoqlashtirish',
   Crop: 'Kesib olish',
   Resize: "O'lchamini o'zgartirish",
   Orientation: 'Orientatsiya',
   Brightness: 'Yorqinligi',
   Sharpen: 'Keskinligi',
   Contrast: 'Ravshanligi',
   'Color levels': 'Rang sathi',
   Gamma: 'Gamma',
   Invert: "Ranglarni ag'darish",
   Apply: "Qo'llash",
   Back: 'Ortga qaytish',
   'Insert date/time': "Kun / vaqtni qo'shish",
   'Date/time': 'Kun/vaqt',
   'Insert link': "Havola qo'shish",
   'Insert/edit link': "Havola qo'shish / tahrirlash",
   'Text to display': "Ko'rsatiladigan matn",
   Url: 'URL',
   Target: 'Nishon',
   None: 'Hech bir',
   'New window': 'Yangi oyna',
   'Remove link': 'Havolani olib tashlash',
   Anchors: 'Langarlar',
   Link: 'Havola',
   'Paste or type a link': 'Havolani joylashtirish yoki kiritish',
   'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?':
      'Siz kiritgan URL elektron pochta manziliga oxshayapti. "mailto:" prefiksi qo\'shilsinmi?',
   'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?':
      'Siz kiritgan URL tashqi havolaga oxshayapti. "http://" prefiksi qo\'shilsinmi?',
   'Link list': "Havolalar ro'yhati",
   'Insert video': "Video qo'shish",
   'Insert/edit video': "Videoni qo'shish / tahrirlash",
   'Insert/edit media': "Media qo'shish / tahrirlash",
   'Alternative source': 'Muqobil manba',
   Poster: 'Poster',
   'Paste your embed code below:': 'Kodni quyiga joylashtiring:',
   Embed: 'Ichiga olgan',
   Media: 'Media',
   'Nonbreaking space': "Buzilmas bo'sh joy",
   'Page break': 'Yangi bet',
   'Paste as text': "Tekst qo'shish",
   Preview: "Tahrirni avvaldan ko'rish",
   Print: 'Chop etish',
   Save: 'Saqlash',
   Find: 'Qidirish',
   'Replace with': 'bilan almashtirish',
   Replace: 'Almashtirish',
   'Replace all': 'Barchasini almashtirish',
   Prev: 'Avvalgisi',
   Next: 'Keyingisi',
   'Find and replace': 'Topib almashtirish',
   'Could not find the specified string.': 'Belgilangan satr topilmadi.',
   'Match case': "O'xshashliklar",
   'Whole words': "Butun so'z",
   Spellcheck: 'Imloni tekshirish',
   Ignore: "E'tiborsiz qoldirish",
   'Ignore all': "Barchasini e'tiborsiz qoldirish",
   Finish: 'Tugatish',
   'Add to Dictionary': "Lug'atga qo'shish",
   'Insert table': "Jadvalni qo'shish",
   'Table properties': 'Jadval xususiyatlari',
   'Delete table': "Jadvalni o'chirib tashlash",
   Cell: 'Katak',
   Row: 'Satr',
   Column: 'Ustun',
   'Cell properties': 'Katak hususiyatlari',
   'Merge cells': 'Kataklarni birlashtirish',
   'Split cell': "Kataklarni bo'lish",
   'Insert row before': "Yuqorisiga satr qo'shish",
   'Insert row after': "Ketidan satr qo'shish",
   'Delete row': 'Satrni olib tashlash',
   'Row properties': 'Satr hususiyatlari',
   'Cut row': 'Satrni kesib olish',
   'Copy row': "Satrdan nusxa ko'chirish",
   'Paste row before': 'Yuqorisiga satrni joylashtirish',
   'Paste row after': 'Ketidan satrni joylashtirish',
   'Insert column before': "Ustunni oldi tomoniga qo'shish",
   'Insert column after': "Ustunni ketidan qo'shish",
   'Delete column': 'Ustunni olib tashlash',
   Cols: 'Ustunlar',
   Rows: 'Satrlar',
   Width: 'Kengligi',
   Height: 'Balandligi',
   'Cell spacing': 'Kataklar orasi',
   'Cell padding': "Kataklar chegarasidan bo'sh joy",
   Caption: 'Taglavha',
   Left: 'Chapga',
   Center: 'Markazga',
   Right: "O'ngga",
   'Cell type': 'Katak turi',
   Scope: 'Muhit',
   Alignment: 'Tekislash',
   'H Align': 'Gorizontal tekislash',
   'V Align': 'Vertikal tekislash',
   Top: 'Yuqoriga',
   Middle: 'Markaziga',
   Bottom: 'Tagiga',
   'Header cell': 'Sarlavha katagi',
   'Row group': 'Satrlar guruhi',
   'Column group': 'Ustunlar guruhi',
   'Row type': 'Satr turi',
   Header: 'Sarlavha',
   Body: 'Tanasi',
   Footer: 'Tag qismi',
   'Border color': 'Chegara rangi',
   'Insert template': "Andozani qo'shish",
   Templates: 'Andozalar',
   Template: 'Andoza',
   'Text color': 'Matn rangi',
   'Background color': 'Orqa fon rangi',
   'Custom...': "O'zgacha...",
   'Custom color': "O'zgacha rang",
   'No color': 'Rangsiz',
   'Table of Contents': 'Mundarija',
   'Show blocks': "Bloklarni ko'rsatish",
   'Show invisible characters': "Ko'rinmas belgilarni ko'rsatish",
   'Words: {0}': "So'zlar soni: {0}",
   '{0} words': '{0} so`z',
   File: 'Fayl',
   Edit: 'Tahrirlash',
   Insert: "Qo'shish",
   View: "Ko'rish",
   Format: 'Shakllar',
   Table: 'Jadval',
   Tools: 'Vositalar',
   'Powered by {0}': '{0} bilan ishlaydi',
   'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help':
      'Murakkab matn maydoni. Menyu uchun ALT-F9 tugmalarini bosing. Vositalar paneli uchun ALT-F10 tugmasini bosing. Yordamni chaqirish uchun ALT-0-ni bosing',
};
export default locale;
